package com.tovtalk.ui.platform

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import kotlinx.browser.document
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader

@Composable
actual fun rememberProfilePhotoPicker(onResult: (ByteArray?, String?) -> Unit): () -> Unit {
    val input = remember {
        (document.createElement("input") as HTMLInputElement).apply {
            type = "file"
            accept = "image/*"
            style.display = "none"
        }
    }

    DisposableEffect(Unit) {
        document.body?.appendChild(input)

        input.addEventListener("change", { _ ->
            val file = input.files?.item(0)
            if (file != null) {
                val reader = FileReader()
                reader.onload = {
                    try {
                        val arrayBuffer = reader.result
                        val bytes = js("new Int8Array(arrayBuffer)").unsafeCast<ByteArray>()
                        onResult(bytes, file.name)
                    } catch (e: Throwable) {
                        onResult(null, null)
                    }
                    input.value = ""
                    Unit
                }
                reader.onerror = {
                    onResult(null, null)
                    input.value = ""
                    Unit
                }
                reader.readAsArrayBuffer(file)
            } else {
                input.value = ""
            }
        })

        onDispose {
            input.remove()
        }
    }

    return { input.click() }
}
